import { observeElement } from '@uvocore-front/utils';

import TestimonialsSlider from './TestimonialsSlider';
import template from './TestimonialTemplate';

observeElement({
  element: '[data-testimonials-widget-js]',
  marginValue: 800,
  callback: () => {
    const testimonialsNode = document.querySelector('.testimonials');
    const testimonialsContainer = document.querySelector('.testimonials__container');
    // Check if custom testimonials are already present
    if (testimonialsContainer.children.length > 0) {
      // Custom testimonials are present, initialize the slider
      TestimonialsSlider();
    } else {
      // No custom testimonials, fetch from API
      fetch('/assets/testimonials/list.json?siteId=14&limit=10&minBodyLength=60&maxBodyLength=90')
        .then((response) => response.json())
        .then((responseData) => {
          const { testimonials } = responseData.data;
          const loaderElement = testimonialsNode.querySelector('.Loader');
          if (loaderElement) {
            testimonialsNode.removeChild(loaderElement);
          }
          const tmNodes = testimonials.map((tm) => template(tm)).join('');
          testimonialsContainer.insertAdjacentHTML('afterbegin', tmNodes);
          TestimonialsSlider();
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error fetching testimonials:', error);
          // Handle error (e.g., display error message)
        });
    }
  },
});
